import React from "react";

const CLOUDS = [
  ["-8%", "4%", 520, 150], ["38%", "-2%", 620, 170], ["72%", "8%", 480, 140],
  ["10%", "30%", 420, 120], ["58%", "34%", 560, 130],
];
const STREAKS = [["-5%", "20%", 700], ["40%", "44%", 820], ["20%", "60%", 640]];

export const SkyBackdrop = () => (
  <div className="sky-backdrop" aria-hidden="true" data-testid="sky-backdrop">
    {CLOUDS.map(([left, top, w, h], i) => (
      <span key={`c${i}`} className="cloud" style={{ left, top, width: w, height: h, animationDelay: `${-i * 7}s` }} />
    ))}
    {STREAKS.map(([left, top, w], i) => (
      <span key={`s${i}`} className="streak" style={{ left, top, width: w, animationDelay: `${-i * 9}s` }} />
    ))}
  </div>
);

export default SkyBackdrop;
